module.exports = __webpack_public_path__ + "img/Logo_Universitaet_des_Saarlandes.f9648961.png";